// Third-party imports
import React from 'react';
import {
  DataTable,
} from 'react-admin';

// Local imports - types
import type { Repair } from '@src/types';

const formatDate = (dateString: string | undefined) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString();
};

const RepairDataTable = () => {
  return (
    <DataTable bulkActionButtons={false} rowClick="edit">
      <DataTable.Col
        label="Repair ID"
        render={(record: Repair) => record.uuid?.substring(0, 8) || ''}
      />
      <DataTable.Col source="status" label="Status" sx={{ width: '8vw' }} />
      <DataTable.Col
        label="Repair Type"
        render={(record: Repair) => record.types?.join(', ') || ''}
      />
      <DataTable.Col source="customerName" label="Customer Name" disableSort sx={{ width: '10vw' }} />
      <DataTable.Col source="customerEmail" label="Customer Email" disableSort />
      <DataTable.Col
        source="dateInitiated"
        label="Initiated Date"
        render={(record: Repair) => formatDate(record.dateInitiated)}
      />
      <DataTable.Col
        source="dateUpdated"
        label="Last Updated"
        render={(record: Repair) => formatDate(record.dateUpdated)}
      />
    </DataTable>
  );
};

export default RepairDataTable;
